import { useQuery } from '@components/useQuery';

interface IUsePagination {
  pageNumber: number;
  pageIndex: number;
}

export function usePagination(paramName = 'page'): IUsePagination {
  const query = useQuery();

  const pageNumber = +(query.get(paramName) ?? 1);
  return { pageIndex: pageNumber - 1, pageNumber };
}
